export default __webpack_public_path__ + "static/media/himanshu-bhardwaj.c69ec64d.jpg";